import React, { FC } from 'react'

interface FollowerProps {
  followingCount: number
  followerCount: number
}

const FollowerInfo: FC<FollowerProps> = ({ followingCount, followerCount }) => {
  return (
    <div className="flex gap-x-2">
      <p className="flex flex-1 items-center gap-x-1 text-xs text-slate-500">
        <span className="text-base font-medium text-slate-950">
          {followingCount || 0}
        </span>
        Following
      </p>
      <p className="flex flex-1 items-center gap-x-1 text-xs text-slate-500">
        <strong className="text-base font-medium text-slate-950">
          {followerCount || 0}
        </strong>
        Followers
      </p>
    </div>
  )
}

export default FollowerInfo
